"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.huZones = void 0;
var huZones = exports.huZones = [{
  id: 'BUDAPEST',
  name: 'Budapest',
  country: 'HU',
  cornerNW: {
    latitude: 47.6139,
    longitude: 18.9396
  },
  cornerSE: {
    latitude: 47.3520,
    longitude: 19.3317
  },
  subZones: [{
    name: 'Budapest Vár',
    zipcodes: {
      1011: {
        label: '1011'
      }
    }
  }, {
    name: 'Budapest Margit körút',
    zipcodes: {
      1024: {
        label: '1024'
      }
    }
  }, {
    name: 'Budapest Belváros',
    zipcodes: {
      1051: {
        label: '1051'
      }
    }
  }, {
    name: 'Budapest Ferencváros',
    zipcodes: {
      1095: {
        label: '1095'
      }
    }
  }, {
    name: 'Budapest Lágymányos',
    zipcodes: {
      1111: {
        label: '1111'
      }
    }
  }, {
    name: 'Budapest Budakeszi',
    zipcodes: {
      1121: {
        label: '1121'
      }
    }
  }, {
    name: 'Budapest Buda',
    zipcodes: {
      1132: {
        label: '1132'
      }
    }
  }]
}];